import React from 'react';
import { Navigate } from 'react-router-dom';
import _ from 'lodash';
import queryString from 'query-string';
import Navigation from '../_components/Navigation';
import LoadingPageContent from 'Components/LoadingPageContent';
import BookingOptionsEditForm from 'Components/BookingOptionsEditForm';
import { userService, accountService } from '../_services';
import { withAuthenticatedUser } from 'Components/withAuthenticatedUser';
import { withRouter } from 'Components/withRouter';

class BookingOptionsPage extends React.Component {
    constructor(props) {
        super(props);

        var initialState = {
            loaded: false,
            bookingOptions: null,
            saveNotification: null
        };

        this.state = initialState;
        
        this.onAccountChange = this.onAccountChange.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);
    }

    fetchData = (account) => {

        var currentUser = this.props.authenticatedUser;

        var selectedAccount = null;

        if (currentUser.accounts && currentUser.accounts.length > 0) {

            if (account)
                selectedAccount = _.find(currentUser.accounts, a => a.value === account);

            if (!selectedAccount) {
                if (currentUser.default_account) {
                    selectedAccount = _.find(currentUser.accounts, a => a.value === currentUser.default_account);
                } else {
                    selectedAccount = currentUser.accounts[0];
                }
            }
        }

        if (selectedAccount) {
            accountService.getBookingOptions(selectedAccount.value)
                .then(response => {

                    if (response.status === 200) {

                        var state = {
                            loaded: true,
                            bookingOptions: response.data
                        };
        
                        this.setState(state);
                    }
                    
                })
                .catch(error => {
                    console.log(error);
                });
        } else {
            this.setState({
                loaded: true
                });
        }
    }

    componentDidMount() {
        const values = queryString.parse(this.props.router.location.search);
        this.fetchData(values.account);
    }

    onAccountChange(account) {

        
        accountService.getBookingOptions(account)
            .then(response => {

                if (response.status === 200) {

                    var bookingOptions = response.data;

                    var state = {
                        loaded: true,
                        bookingOptions: bookingOptions
                    }

                    this.setState(state);
                }
            })
            .catch(error => console.log(error));
    }

    onFormSubmit(formData) {

        var bookingOptions = {};

        var checkboxKeys = ['ref1_required', 'ref2_required', 'include_price_markup'];

        formData.forEach((value, key) => {
            if (_.some(checkboxKeys, k => k === key)) {
                bookingOptions[key] = (value === 'on' ? true : false);
            }
            else {
                bookingOptions[key] = value;
            }
        });

        checkboxKeys.forEach(k => {
            if (formData.has(k) !== true) {
                bookingOptions[k] = false;
            }
        });

        accountService.setBookingOptions(bookingOptions)
            .then(response => {
                if (response.status === 200) {

                    alert(response.message || 'Saved');

                    var url = '/admin_booking_options?account=' + bookingOptions.account;
                    this.props.router.navigate(url, { replace: true });
                }
            })
            .catch(error => alert(error));
    }

    render() {

        if (!this.state.loaded) {
            return (<LoadingPageContent />);
        }

        var privileges = null;
        var accounts = null;

        if (this.props.authenticatedUser) {
            privileges = this.props.authenticatedUser.privileges;
            accounts = this.props.authenticatedUser.accounts;
        }

        var canModifyBookingOptions = privileges &&
            _.some(privileges, ['description', 'Modify Booking Options']);

        if (!canModifyBookingOptions)
            return <Navigate to="/Welcome" />

        return (
            <div id="bookingOptions">
                <Navigation active="admin" authenticatedUser={this.props.authenticatedUser} />
                <div className="container-fluid padding-lr55 bg-form">
                    <div className="row h3">
                        <div className="col-xs-12">Booking Options</div>
                    </div>
                </div>
                <div className="container-fluid padding-lr55 bg-form">
                    <BookingOptionsEditForm
                        accounts={accounts}
                        bookingOptions={this.state.bookingOptions}
                        onAccountChange={this.onAccountChange}
                        onFormSubmit={this.onFormSubmit}
                        />
                </div>
            </div>);
    }
}

const AuthenticatedBookingOptionsPage = withAuthenticatedUser(withRouter(BookingOptionsPage));

export { AuthenticatedBookingOptionsPage as BookingOptionsPage };